import {prop} from 'ramda';

import {DASHBOARD_TILE_CATALOGUE} from '../consts/dashboardTileCatalogue';
import {DASHBOARD_TILE_IDS} from '../consts/dashboardTileIds';
import {DashboardTilePlacement} from '../types/DashboardTilePlacement';

export function buildDefaultDashboardArrangement(): DashboardTilePlacement[] {
  return DASHBOARD_TILE_IDS.map((id) => ({
    id,
    size: prop(id, DASHBOARD_TILE_CATALOGUE).defaultSize,
    isVisible: true,
  }));
}
